<template>

<app-wrapper class="transitions">

    <div class="transitions-move is-left" v-on:click="onLeftClick" v-if="page.slides.length > 1"><app-icon name="caret-left" /></div>

    <div class="transitions-wrapper">

        <com-slide v-on:focus="onFocus" v-on:blur="onBlur" :position="position(index)" :active="index === current" v-for="(slide, index) in page.slides" :key="index" :slide="slide" />

    </div>

    <div class="transitions-move is-right" v-on:click="onRightClick" v-if="page.slides.length > 1"><app-icon name="caret-right" /></div>

</app-wrapper>

</template>

<script>

import comSlide from './transitions/Slide'

export default {

    components: {
        'com-slide': comSlide
    },

    data: function() {

        return {
            current: 0,
            timer: false,
            delay: 6000,
            direction: 'right'
        }

    },

    created: function() {

        this.setupTimer()

    },

    beforeDestroy: function() {

        clearTimeout(this.timer)

    },

    methods: {
        
        position: function(index) {

            return (index > this.current) ? 'right' : 'left'

        },

        onFocus: function() {

            clearTimeout(this.timer)

        },

        onBlur: function() {

            this.setupTimer()

        },

        setupTimer: function() {

            this.timer = this.$_.delay(this.onRightClick, this.delay)

        },

        onLeftClick: function() {

            clearTimeout(this.timer)

            this.current = (this.current > 0) ? this.current - 1 : this.page.slides.length - 1

            this.setupTimer()

        },

        onRightClick: function() {

            clearTimeout(this.timer)

            this.current = (this.current < this.page.slides.length - 1) ? this.current + 1 : 0

            this.setupTimer()

        }
    
    }

}

</script>

<style scoped>

.transitions {
    height: 360px;
    overflow: hidden;
    background-image: url(~@/assets/app.load.gif);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    z-index: 1;
}

.is-mobile .transitions {
    height: 240px;
}

.transitions-wrapper {
    width: 100%;
    height: 100%;
    z-index: 1;
}

.transitions-move {
    position: absolute;
    height: 40px;
    width: 40px;
    top: 50%;
    background-color: var(--color-blue-light);
    color: #fff;
    font-size: 24px;
    margin-top: -20px;
    display: flex;
    flex-direction: row;
    transition: all 100ms linear;
    cursor: pointer;
    z-index: 2;
}

.is-mobile .transitions-move {
    display: none;
}

.transitions-move >>> .icon {
    width: 40px;
    line-height: 40px;
    text-align: center;
}

.transitions-move.is-left {
    left: 0px;
    justify-content: flex-end;
    border-radius: 0px 4px 4px 0px;
}

.transitions-move.is-right {
    right: 0px;
    justify-content: flex-start;
    border-radius: 4px 0px 0px 4px;
}

.transitions-move:hover {
    width: 48px;
    background-color: var(--color-blue-dark);
}

</style>
